/* eslint-disable import/no-unresolved */
import React, { useEffect, useState } from 'react';
import { useQuery } from '@apollo/client';
import moment from 'moment';
import { GET_TITLE_BY_REVIEWER_ID } from '../../../queries/titleWriter';
import ListTitles from './ListTitles';
import HeaderTitles from './HeaderTitles';
import { GET_WRITERS } from '../../../queries/user';
import { usePermissions } from '../../../store/permissions.context';
import { UserService } from '../../../services/User/UserService';
import { useUserData } from '../../../hooks/context/userUserData.hook';
import Layout from '../../../components/Layout/Layout';

export default function QueryTitlesReviewer() {
  const [user] = useUserData();
  const [permissions, setPermissions] = usePermissions();
  const [writers, setWriters] = useState([]);
  const [filterWriter, setFilterWriter] = useState(null);
  const [titles, setTitles] = useState([]);
  const [isByPublishPost, setIsByPublishPost] = useState(false);
  const [selectedStartDate, setSelectedStartDate] = useState(
    moment().add(-6, 'days').startOf('day').toDate(),
  );
  const [selectedEndDate, setSelectedEndDate] = useState(
    moment().endOf('day').toDate(),
  );
  const [dateTypeFilter, setDateTypeFilter] = useState('Last7Days');
  const [statusCanBeOpened, setStatusCanBeOpened] = useState([]);
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [total, setTotal] = useState(10);
  const [filterSearchText, setFilterSearchText] = useState(null);
  const [filterStatus, setFilterStatus] = useState(null);
  const [sites, setSites] = useState([]);

  useEffect(() => {
    async function getSites() {
      const userService = new UserService(user.id);
      const sites = await userService.getAllowedSites();
      setSites(sites);
    }
    getSites();
  }, [user.id]);

  const queryTitles = useQuery(GET_TITLE_BY_REVIEWER_ID, {
    variables: {
      offset: page * limit,
      limit,
      dateStart: selectedStartDate,
      dateEnd: selectedEndDate,
      searchText: filterSearchText,
      status: filterStatus,
      writer: filterWriter,
      sites,
      byPublishPost: isByPublishPost,
    },
    fetchPolicy: 'network-only',
  });
  const { loading, error, refetch } = queryTitles;
  const queryWriters = useQuery(GET_WRITERS);
  const refetchTitles = () => {
    queryTitles.refetch();
  };
  useEffect(() => {
    if (queryTitles.data) {
      const {
        data: {
          titlesAsReviewer: { titles, permissions, total },
        },
      } = queryTitles;
      setTitles(titles);
      setTotal(total);
      setPermissions(permissions);
      setStatusCanBeOpened(permissions.statusCanBeOpened);
    }
  }, [queryTitles, setPermissions]);

  useEffect(() => {
    if (queryWriters.data) {
      const {
        data: { userWriters },
      } = queryWriters;
      setWriters(userWriters);
    }
  }, [queryWriters]);

  return (
    <Layout>
      <HeaderTitles
        titles={titles}
        filterStatus={filterStatus}
        setFilterStatus={setFilterStatus}
        isByPublishPost={isByPublishPost}
        setIsByPublishPost={setIsByPublishPost}
        selectedStartDate={selectedStartDate}
        setSelectedStartDate={setSelectedStartDate}
        selectedEndDate={selectedEndDate}
        setSelectedEndDate={setSelectedEndDate}
        setPage={setPage}
        dateTypeFilter={dateTypeFilter}
        setDateTypeFilter={setDateTypeFilter}
        writers={writers}
        filterWriter={filterWriter}
        setFilterWriter={setFilterWriter}
        permissions={permissions}
      />
      <ListTitles
        titles={titles}
        setTitles={setTitles}
        total={total}
        loading={loading}
        error={error}
        refetch={refetch}
        refetchTitles={refetchTitles}
        setFilterSearchText={setFilterSearchText}
        setLimit={setLimit}
        setPage={setPage}
        limit={limit}
        page={page}
        statusCanBeOpened={statusCanBeOpened}
      />
    </Layout>
  );
}
